import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Dropdown } from '../global/fields/Dropdown';
import { AtLeast } from '../../types/common';
import { Component, HrefLang } from '../../types/schema';
import { withCssModulesClassNames } from '../../common/nextMigrationHelpers';
import { default as styles } from '../../scss/components/SwatchesDropdown.module.scss';
import { getHrefLang } from '../../store/selectors/general.selectors';

const withCssModulesClassNamesHandler = withCssModulesClassNames(styles);

const SwatchesDropdown = ({
  points,
}: AtLeast<Component, 'points'>) => {
  const [dropdownValue, setDropdownValue] = useState('');
  const hrefLang = useSelector(getHrefLang);

  const handleOnDropdownChange = (value: string) => {
    if (hrefLang !== HrefLang.EN_US && !value.includes(hrefLang)) {
      // eslint-disable-next-line no-param-reassign
      value = `/${hrefLang}${value}`;
    }

    window.location.assign(value);
  };

  useEffect(() => {
    let { pathname } = window.location;
    if (hrefLang !== HrefLang.EN_US && pathname.includes(hrefLang)) {
      pathname = pathname.replace(`/${hrefLang}`, '');
    }

    const point = points?.find(({ anchor }) => pathname === anchor);

    if (point?.anchor) {
      setDropdownValue(point.anchor);
    }
  }, []);

  return (
    <div className={withCssModulesClassNamesHandler('form-fancy-wrapper', 'swatches-dropdown-container')}>
      <Dropdown
        onChange={handleOnDropdownChange}
        value={dropdownValue}
        options={
          points?.map((point) => ({
            label: point.header,
            value: point.anchor,
          })) || []
        }
      />
    </div>
  );
};

export default SwatchesDropdown;
